// Bootstrap global js dependencies
try {
  window.axios = require('axios');

  window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
} catch (e) {
  throw new Error('Dependencies not loaded');
}

const token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
  throw new Error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js